import type { UseListProps, UseListResult } from '@ztechapps/common.hook'
import { useList } from '@ztechapps/common.hook'
import { query } from './graphql'
import type { SetOptional } from 'type-fest'
import merge from 'lodash/merge'

export type UseCustomerAddressProps = SetOptional<UseListProps, 'query' | 'entity'> & { showAll?: boolean }
export const useCustomerAddress = ({ sort, limit, options, ...rest }: UseCustomerAddressProps): UseListResult => {
  sort = sort ?? { fullAddress: 1 }
  limit = limit ?? 0

  options = merge({}, options, {
    queryOptions: {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  })
  return useList({
    query,
    entity: 'getCustomerAddresses',
    limit,
    sort,
    options,
    ...rest,
  })
}
